<template>
    <div style="display: flex; flex-direction: column; gap: 20px; align-items: center; padding: 10px 0">
        <div :style="{width: `${resolution}px`, height: `${resolution}px`}" style="position: relative;">
            <Camera :blue="blue" :purple="purple" @update="updateEvt" :size="resolution" :resolution="resolution"/>
            <div style="position: absolute; width: 100%; height: 100%; pointer-events: none; top: 0">
                <template v-for="(object, index) in objects" :key="index">
                    <div :class="{blue: blue}" class="box" :style="{top: `${object.minY * this.resolution}px`, left: `${object.minX * this.resolution}px`, 
                            width: `${object.width * this.resolution}px`, height: `${object.height * this.resolution}px`}">
                        <div class="label">
                            {{object.class}} {{object.score}}%
                        </div>
                    </div>
                </template>
            </div>
        </div>
        <div class="threshold" :class="{blue: blue}">
            Threshold
            <div class="slidecontainer">
                <input type="range" min="0.05" max="1" v-model="threshold" class="slider" id="myRange" step="0.05" > 
            </div>
            <label style="width: 30px; min-width: 30px; font-weight: 600;"> {{ threshold * 100 }}% </label>
        </div>
        <input type="file" @input="uploadEvt">
    </div>
</template>

<script>
import { Box, Camera } from '@/index.js'
import JSZip from 'jszip';
import axios from 'axios';
import * as tf from '@tensorflow/tfjs'

export default {
    emits: ['result', 'init'],
    props: {
        default: {
            type: Boolean,
            default: false
        },
        resolution: {
            type: Number,
            default: 240
        },
        blue: {
            type: Boolean,
            default: false
        },
        purple: {
            type: Boolean,
            default: false
        }
    },
    components:{
        Camera,
        Box
    },
    data(){
        return{
            isRunning: false,
            isSkip: false,
            objects: [],
            threshold: 0.35,
            lables: [],
            worker: null
        }
    },
    methods: {
        processBoxes(scores, boxes, classes, scores2){
            const objects = []
            scores.forEach((score, i) => {
                if (score > 0.5) {
                    const minY = boxes[0][i][0]
                    const minX = boxes[0][i][1]
                    const maxY = boxes[0][i][2]
                    const maxX = boxes[0][i][3]
                    objects.push({
                        class: classes[i],
                        score: score.toFixed(4),
                        score2: scores2[i],
                        minY: minY,
                        minX: minX,
                        width: maxX - minX,
                        height: maxY - minY
                    })
                    console.log(scores2[i])
                }
            })
            return objects
        },
        processInput(canvas){
            const tfimg = tf.browser.fromPixels(canvas);
            const expandedimg = tfimg.transpose([0,1,2]).expandDims();
            return expandedimg;
        },
        async updateEvt(canvas) {
            await tf.setBackend('webgl');
            if(!this.model) return;
            if(this.isRunning) return;

            this.isRunning = true
            tf.engine().startScope();

            const processedInput = this.processInput(canvas)
            const outputTfJs = await this.model.executeAsync(processedInput);

            const boxes = outputTfJs[this.index.boxes].arraySync()
            const scores = outputTfJs[this.index.scores].dataSync()
            const scroes2 = outputTfJs[this.index.scores2].arraySync()[0]
            const classes = outputTfJs[this.index.classes].dataSync()

            this.objects = this.processBoxes(scores, boxes, classes, scroes2)
            console.log(this.objects)

            tf.engine().endScope();
            this.isRunning = false
        },
        async updateThresholdEvt(){
            this.worker?.postMessage({threshold: this.threshold})
        },
        async uploadEvt(event){
            const file = event.target.files[0];

            if (file) {
                const reader = new FileReader();
                reader.onload = async () => {
                    const zipData = reader.result;
                    const jsZip = new JSZip();
                    const unzip = await jsZip.loadAsync(zipData);
                    const files = []

                    const desiredOrder = [ /model\.json$/, 
                        /group1-shard1of3\.bin$/, 
                        /group1-shard2of3\.bin$/, 
                        /group1-shard3of3\.bin$/];
                    const rearrangedObject = {};
                    desiredOrder.forEach(pattern => {{
                        Object.keys(unzip.files).forEach(key => {
                            if (pattern.test(key)) {
                                rearrangedObject[key] = unzip.files[key];
                            }
                        });
                    }})

                    for (const key in rearrangedObject) {
                        const file = rearrangedObject[key]
                        if (!file.dir) {
                            const blob = await file.async("blob")
                            const fileObj = new File([blob], file.name);
                            files.push(fileObj)
                        }
                    }
                    console.log(files)
                    await this.loadModel(tf.io.browserFiles(files))
                };
                reader.readAsArrayBuffer(file);
            }
        },
        async loadModelFromBlob(blob){
            const jsZip = new JSZip();
            const unzip = await jsZip.loadAsync(blob);
            const files = []

            const desiredOrder = [ /model\.json$/, 
                /group1-shard1of3\.bin$/, 
                /group1-shard2of3\.bin$/, 
                /group1-shard3of3\.bin$/];
            const rearrangedObject = {};
            desiredOrder.forEach(pattern => {{
                Object.keys(unzip.files).forEach(key => {
                    if (pattern.test(key)) {
                        rearrangedObject[key] = unzip.files[key];
                    }
                });
            }})

            for (const key in rearrangedObject) {
                const file = rearrangedObject[key]
                if (!file.dir) {
                    const blob = await file.async("blob")
                    const fileObj = new File([blob], file.name);
                    files.push(fileObj)
                }
            }
            await this.loadModel(tf.io.browserFiles(files))
        },
        async loadModel(modelArtifacts){
            const mapIndex = (outputName) => {
                function removeEndingZero(str) {
                    if (str.endsWith(':0')) {
                        return str.slice(0, -2); // Remove the last 2 characters
                    }
                    return str; // Return the original string if it doesn't end with :0
                }
                return this.model.outputs.findIndex(output => {
                    return output.name == removeEndingZero(this.model.signature.outputs[outputName].name)
                })
            }

            this.model = await tf.loadGraphModel(modelArtifacts);

            const detectionClassesIndex = mapIndex('Identity_2:0')
            const detectionBoxesIndex = mapIndex('detection_boxes')
            const detectionScoresIndex = mapIndex('Identity_4:0')
            const detectionScores2Index = mapIndex('detection_multiclass_scores')

            this.index = {
                boxes: detectionBoxesIndex,
                classes: detectionClassesIndex,
                scores: detectionScoresIndex,
                scores2: detectionScores2Index,
            }
        },
    },
    async mounted(){
        if (this.default) {
            /* const worker = new Worker(new URL('./worker.js', import.meta.url), {type: 'module'});
            this.worker = worker

            this.worker.addEventListener('message', async (e) => {
                const { type } = e.data 
                if (type == 'init') {
                    const { labels } = e.data
                    this.$emit('init', labels)
                    return
                }
                if (type == 'result') {
                    const { result } = e.data
                    this.objects = result
                    this.$emit('init', result)
                    return
                }
                if (type == 'threshold') {
                    const { threshold } = e.data
                    this.threshold = threshold
                    return
                }
            }) */
        }
    },
    beforeUnmount(){
        if (this.worker) {
            this.worker.terminate()
        }
    },
    watch: {
        threshold(){
            this.updateThresholdEvt()
        }
    }
}
</script>

<style scoped>
.box{
    position: absolute; border: 1px dotted white; 
    background: rgba(112,83,163, 0.5); border-radius: 0;
    box-sizing: border-box;
    box-sizing: content-box;
}

.box .label{
    width: max-content; height: max-content; 
    background: rgba(112,83,163); color: white; 
    border-radius: 0; padding: 5px; max-height: 30px; border: 1px dotted white; 
    white-space: nowrap; position: absolute; transform: translateY(-100%);
    left: -1px;
}

.box.blue{
    background: rgba(25,102,210, 0.5);
}
.box.blue .label{
    background: rgba(25,102,210, 0.5);
}
</style>

<style scoped>
.slidecontainer {
    width: 100%; /* Width of the outside container */
    display: flex;
    align-items: center;
}

/* The slider itself */
.slider {
    -webkit-appearance: none;  /* Override default CSS styles */
    appearance: none;
    width: 100%; /* Full-width */
    height: 8px; /* Specified height */
    background: #d3d3d3; /* Grey background */
    outline: none; /* Remove outline */
    opacity: 0.7; /* Set transparency (for mouse-over effects on hover) */
    -webkit-transition: .2s; /* 0.2 seconds transition on hover */
    transition: opacity .2s;
    border-radius: 2.5px;
}

/* Mouse-over effects */
.slider:hover {
    opacity: 1; /* Fully shown on mouse-over */
}

/* The slider handle (use -webkit- (Chrome, Opera, Safari, Edge) and -moz- (Firefox) to override default look) */
.slider::-webkit-slider-thumb {
    -webkit-appearance: none; /* Override default look */
    appearance: none;
    width: 14px; /* Set a specific slider handle width */
    height: 14px; /* Slider handle height */
    background: #8a66c7; /* Green background */
    cursor: pointer; /* Cursor on hover */
    border-radius: 50%;
}

.blue .slider::-webkit-slider-thumb{
    background: #1967D2;
}

.slider::-moz-range-thumb {
    width: 14px; /* Set a specific slider handle width */
    height: 14px; /* Slider handle height */
    background: #8a66c7; /* Green background */
    cursor: pointer; /* Cursor on hover */
}

.blue .slider::-moz-range-thumb{
    background: #1967D2;
}
</style>

<style scoped>
.threshold{
    display: flex; gap: 10px; color: #8a66c7; font-weight: 600; align-items: center; padding: 0 10px;
}

.threshold.blue{
    color: #1967D2;
}
</style>